import { createContext, PropsWithChildren, useContext } from "react"
import { useAccountAspect } from "../AccountAspectContext"
import { useEngagement } from "./queries/useEngagement"
import { getEngagementStateFlags } from "./utils/getEngagementStateFlags"
import { EngagementContext } from "./types"

const initialContext: EngagementContext = {
  engagement: undefined,
  ...getEngagementStateFlags(),
}

const EngagementContext = createContext<EngagementContext>(initialContext)

export const useEngagementContext = () => {
  const context = useContext(EngagementContext)

  if (!context) throw new Error("useEngagementContext must be called within EngagementProvider")

  return context
}

const TeamMemberEngagementProvider = ({ children }: PropsWithChildren<unknown>) => {
  const { accountAspect } = useAccountAspect()
  const { loading, data } = useEngagement(accountAspect)

  // todo handle errors
  if (loading) return null

  const engagement = data?.engagement || undefined
  const state = data?.engagement.state

  return (
    <EngagementContext.Provider
      value={{
        engagement,
        ...getEngagementStateFlags(state),
      }}
    >
      {children}
    </EngagementContext.Provider>
  )
}

export const EngagementProvider = ({ children }: PropsWithChildren<unknown>) => {
  const { isContractor, isEmployee } = useAccountAspect()

  if (isContractor || isEmployee) {
    return <TeamMemberEngagementProvider>{children}</TeamMemberEngagementProvider>
  }

  return <EngagementContext.Provider value={initialContext}>{children}</EngagementContext.Provider>
}
